export const isProduct = (product) => product?.affiliate_url && product?.title;

export const isBuyFromSuggestion = (product) =>
  product?.affiliate_url && !product?.title && product.vendor_name;

export const isUnknownUrl = (product) =>
  product?.affiliate_url && !product?.title && !product.vendor_name && product.display_text;
